import type { DraftSaveStatus } from "../store/schema/ComposeViewState";

export default function isLastSaveSuccess(draftSaveStatus: DraftSaveStatus): draftSaveStatus is string {
    return typeof draftSaveStatus === "string";
}
